import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spin2 } from "components";
import { getBundleByID, updateBundle } from "../../actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toastAlert } from "@paylixecommerce/shared/components";
import { ProductMultiSelect, SimpleSelect, Text } from "components/fields";
import { useHistory, useParams } from "react-router-dom";
import config from "constants/config";

import "./../style.scss";


const validationSchema = Yup.object().shape({
	title: Yup.string().required('Title is required'),
	products: Yup.array().min(1, "Select at least one field").of(Yup.object().shape({
		label: Yup.string(),
		value: Yup.string()
	}).nullable()).nullable().required('Product is required'),
	discount_amount: Yup.string().required('Discount amount is required')
});


const CreateNewBundle = () => {

	let [initialValues, setInitialValues] = useState({
		title: '',
		products: [],
		discount_type: 2,
		discount_amount: 10,
	});
	let [loading, setLoading] = useState(false);
	let dispatch = useDispatch()
	let history = useHistory();
	let { id } = useParams();

	useEffect(() => {
		dispatch(getBundleByID(id))
			.then(({data: { product_bundle }}) => {
				setInitialValues({
					...product_bundle,
					uniqid: product_bundle.uniqid,
					discount_amount: product_bundle.discount_amount,
					discount_type: product_bundle.discount_type,
					title: product_bundle.title,
					products: product_bundle.products_bound.map(({ uniqid: value, title: label }) => ({ label, value })),
				})
			})
			.finally(() => {
				setLoading(false)
			})
	}, []);

	const onSubmit = (values) => {
		setLoading(true);

		values.products = values.products.map(({ value }) => value).toString();

		dispatch(updateBundle(values))
			.then(res => {
				toastAlert('success', res.message);
				history.push(`/upselling`)
			})
			.catch(err => {
				toastAlert('error', err ? err.error : "");
			})
			.finally(() => {
				setLoading(false)
			});
	}

	let form = useFormik({initialValues, onSubmit, enableReinitialize: true, validationSchema});


	return (
		<>
			<div className="edit-modal-header">
				<div className="edit-modal-header-title">Edit Bundle: {form.values.title}</div>
			</div>

			<form onSubmit={form.handleSubmit} className="edit-modal-body create-bundle-screen-form mb-0">

				<Text label="Bundle Name" name="title" placeholder="Enter Name" {...form} />
				<ProductMultiSelect name="products" {...form} />

				<div className="create-bundle-screen-one-row">
					<SimpleSelect label="Type" options={config.DISCOUNT_TYPE} name="discount_type" {...form} />
					<Text label="Discount Amount" noteUnder name="discount_amount" {...form} placeholder="10" />
				</div>

			</form>

			<div className="edit-modal-footer">
				<Button type="button" size="large" variant="secondary" onClick={() => history.push('/upselling')}>
					Close
				</Button>
				<Button type="button" size="large" onClick={form.handleSubmit}>
					{loading ? <Spin2 /> : "Save Products Bundle"}
				</Button>
			</div>
		</>
	)
}

export default CreateNewBundle
